import { PayCycleAvailableDocumentTypes } from 'ap/paymentCycle/__generated__/PayCycleAvailableDocumentTypes';
import React from 'react';
import { AttachSectionProps } from '..';
import { AttachFormModal } from './AttachFormModal';

export type AttachFormProps = Pick<AttachSectionProps, 'paymentCycle'> & {
  availableDocumentTypes: PayCycleAvailableDocumentTypes | undefined;
};

export const AttachForm: React.FC<AttachFormProps> = ({
  paymentCycle,
  availableDocumentTypes,
}) => {
  return (
    <AttachFormModal
      paymentCycle={paymentCycle}
      availableDocumentTypes={availableDocumentTypes}
    />
  );
};
